import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'components/Amount';
import InfoHoverBlock from 'components/success/InfoHoverBlock';

class AccompagnateurRenoBlock extends React.Component {
  render() {
    const { renoTagOffer, isRenoGlobale, isAudit, mar } = this.props;

    const InfoComponent = () => {
      return (
        <div className="renoItem ">
          <label className="d-flex jcsb !m-0 !p-0">
            <h2 className="whitespace-nowrap">
              - <Amount value={mar} />
            </h2>
          </label>
        </div>
      );
    };

    if (renoTagOffer && isRenoGlobale && !isAudit) {
      return (
        <>
          <div className="flex flex-row justify-between items-center">
            <InfoHoverBlock
              data={this.props.APIresult}
              success={this.props.success}
              item="PrimeAccompagnateur"
              showTooltip
            ></InfoHoverBlock>
            <div>
              <InfoComponent />
            </div>
          </div>
          <div className="hr-reno" />
        </>
      );
    }
    return null;
  }
}

AccompagnateurRenoBlock.propTypes = {
  mar: PropTypes.number.isRequired,
  isAudit: PropTypes.bool.isRequired,
  isRenoGlobale: PropTypes.bool.isRequired,
  renoTagOffer: PropTypes.object.isRequired,
  APIresult: PropTypes.object.isRequired,
  success: PropTypes.string.isRequired,
};

export default AccompagnateurRenoBlock;
